import { useEffect, useState } from "react";
import api from "@/api";

let cached = null;
let pending = null;

export function getPlatformConfig() {
  if (cached) return Promise.resolve(cached);
  if (!pending) {
    pending = api.get("/config/public").then((r) => {
      cached = r.data;
      document.title = cached.platform_name;
      return cached;
    }).catch(() => {
      cached = { platform_name: "Bizora" };
      return cached;
    });
  }
  return pending;
}

export function usePlatformName() {
  const [name, setName] = useState(cached?.platform_name || "Bizora");
  useEffect(() => { getPlatformConfig().then((c) => setName(c.platform_name)); }, []);
  return name;
}

export function hexToHsl(hex) {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  if (!m) return null;
  let [r, g, b] = [parseInt(m[1], 16) / 255, parseInt(m[2], 16) / 255, parseInt(m[3], 16) / 255];
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h = 0, s = 0;
  const l = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
    h *= 60;
  }
  return `${Math.round(h)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

export function isUnavailableBrandColor(hex) {
  const hue = Number(hexToHsl(hex)?.split(" ")[0]);
  return Number.isFinite(hue) && hue >= 50 && hue <= 180;
}

export function themeInputColor(property) {
  return getComputedStyle(document.documentElement).getPropertyValue(property).trim();
}
